import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.html',
  styleUrls: ['./delete-confirmation.scss'],
})
export class DeleteConfirmation {
  readonly title = input('Delete Confirmation');
  readonly message = input('Are you sure you want to delete this data? This action cannot be undone.');
  readonly confirmButtonText = input('Delete');
  readonly cancelButtonText = input('Cancel');

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  close() {
    this.cancelled.emit();
  }

  confirmDelete() {
    this.confirmed.emit();
  }

  cancel() {
    this.cancelled.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('fm-confirm-modal')) {
      this.close();
    }
  }
}
